import { Container, Typography, Box, Grid, Divider, } from '@material-ui/core';
import React, { useEffect } from 'react';
import Aos from 'aos'
import "aos/dist/aos.css"
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

import { Helmet } from 'react-helmet';
import Banner from '../../../asset/images/insight/article_thumbnails/combining-the-power.webp'
import ViewFullWhitepaperNew from '../../../Component/forms/ViewFullWhitepaperNew.js';

import EmployeeProfile from '../../../Component/EmployeeProfile.js';
import AD from '../../../asset/images/team/amit_dhalia.webp'
import Whitepaperback from '../../../Component/Whitepaperback.js';
import ViewFullWhitepaperRightForm from '../../../Component/forms/ViewFullWhitepaperRightForm.js';

export default function DataDrivenBusinesses() {

    useEffect(() => {
        Aos.init({ duration: 1000 });
    }, []);


    const link = "https://objectstorage.ap-mumbai-1.oraclecloud.com/n/bmexgnkisxsv/b/marketing_dpa/o/whitepaper_WP_AI%20for%20BI_The%20Combined%20Powers%20of%20Data-Driven%20Business_v4_reviewed.pdf"

    return (
        <>

            <Helmet>
                <meta charset="UTF-8" />
                <title>AI-BI Synergy: Unlock Real-Time Insights & Smarter Decisions | Whitepaper Download</title>
                <meta name="description" content="Download our whitepaper on the AI-BI synergy and discover how leading companies use AI to unlock real-time insights and drive smarter decisions." />
                <link rel="canonical" href="https://www.decimalpointanalytics.com/whitepapers/ai-bi-synergy-whitepaper" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            </Helmet>


            <Box id="whitepaper-new" >
                <Box className='section sec_bg' mt={6}>
                    <Container maxWidth="lg">

                        <Grid container spacing={4} justifyContent='center'>

                            <Grid item lg={7} md={7} sm={6} xs={12} className='grid-custom-12'>
                                <Box mb={2}>
                                    <Typography variant='h1' className='blue mainhead al_left' style={{ textTransform: 'none' }}>
                                        The AI-BI Synergy: Combining the Power of Artificial Intelligence for Data-Driven Businesses
                                    </Typography>
                                </Box>
                                <Typography variant="h4" className="h4 al_left fw6">
                                    Real-time insights. Faster actions. Smarter decisions.
                                </Typography>

                                <Typography variant="h4" className="black al_left fw4">
                                    Discover how top-performing companies are using AI to supercharge Business Intelligence and act before the window of opportunity closes.
                                </Typography>

                                <Box className='flx_left' mt={4}>
                                    <ViewFullWhitepaperNew reportby={"The AI-BI Synergy: Combining the Power of Artificial Intelligence for Data-Driven Businesses"} btn_name="Download the whitepaper" link={link} />
                                </Box>

                            </Grid>

                            <Grid item lg={5} md={5} sm={6} xs={12} className='grid-custom-12'>
                                <Box >
                                    <img src={Banner} className='brd8 w100' alt='Banner' />
                                </Box>
                            </Grid>

                        </Grid>
                    </Container>
                </Box>

                <Box className='section w_bg'>
                    <Container maxWidth="lg">
                        <Grid container spacing={5} justifyContent='center' alignItems='flex-start'>


                            <Grid item lg={6} md={6} sm={6} xs={12} className='grid-custom-12'>
                                <Grid container spacing={4} alignItems="flex-start">
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                        <Box>
                                            <Typography variant="h4" className="h4 black">
                                                Why This Matters Now
                                            </Typography>

                                            <Typography variant='h6' className='black jst' gutterBottom>
                                                <ul>
                                                    <li>
                                                        <Typography variant='h6' className='black jst'>
                                                            Business users can’t afford to wait for dashboards
                                                        </Typography>
                                                    </li>
                                                    <li>
                                                        <Typography variant='h6' className='black jst'>
                                                            Outdated intel = missed revenue and wrong decisions
                                                        </Typography>
                                                    </li>
                                                    <li>
                                                        <Typography variant='h6' className='black jst'>
                                                            AI unlocks real-time analysis across functions
                                                        </Typography>
                                                    </li>
                                                </ul>


                                            </Typography>

                                            <Box pt={3}>
                                                <Typography variant="h4" className="h4 black fw4">
                                                    Don’t  <span className='lower'> let legacy systems slow your growth.</span>
                                                </Typography>
                                                <Typography variant="h4" className="h4 black fw6">
                                                    Get  <span className='lower'> the guide. </span> Act  <span className='lower'>with intelligence.</span>
                                                </Typography>

                                            </Box>


                                        </Box>

                                    </Grid>
                                </Grid>


                            </Grid>

                            <Grid item lg={6} md={6} sm={6} xs={12} className='grid-custom-12'>
                                <Box  >
                                    <Box className="web_section whitebx sec_bg" >
                                        <Box className='graybbx2222' mt={2}>
                                            <ViewFullWhitepaperRightForm reportby={" The AI-BI Synergy: Combining the Power of Artificial Intelligence for Data-Driven Businesses"} link={link} />
                                        </Box>
                                    </Box>
                                </Box>

                            </Grid>

                            <Grid item lg={12} md={12} sm={21} xs={12} className='grid-custom-12'>
                                <Divider />
                            </Grid>

                            <Grid item lg={12} md={12} sm={21} xs={12} className='grid-custom-12'>
                                <Box >
                                    <EmployeeProfile imgSrc={AD} name={"Mr. Amit Dhalia"} designation={"Vice President - BI and Automation,"} company={"Decimal Point Analytics Pvt. Ltd."} linkedinUrl={"https://www.linkedin.com/in/amit-dhalia-49805547/"} />
                                </Box>
                            </Grid>

                            <Grid item lg={4} md={5} sm={5} xs={12} className='grid-custom-12'>
                                <Whitepaperback />
                            </Grid>


                        </Grid>
                    </Container>
                </Box>
            </Box>

        </>
    );
}